const DATE_ONLY_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

export const parseApiDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
  }

  const text = String(value).trim();
  const match = text.match(DATE_ONLY_REGEX);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(year, month - 1, day, 12, 0, 0, 0);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatApiDate = (value, options, locale = 'es-AR') => {
  const date = parseApiDate(value);
  return date ? date.toLocaleDateString(locale, options) : '-';
};

export const formatDateInputValue = (value) => {
  const date = parseApiDate(value);
  if (!date) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getTodayDateInputValue = () => formatDateInputValue(new Date());

export const isValidDateInputValue = (value) => {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text) {
    return false;
  }

  return formatDateInputValue(text) === text;
};

export const compareApiDatesAsc = (left, right) => {
  const leftTime = parseApiDate(left)?.getTime() ?? Number.NEGATIVE_INFINITY;
  const rightTime = parseApiDate(right)?.getTime() ?? Number.NEGATIVE_INFINITY;
  return leftTime - rightTime;
};

export const compareApiDatesDesc = (left, right) => compareApiDatesAsc(right, left);
